import { Dialog } from "primereact/dialog";

import React from "react";

export default function DialogPR({
  header,
  footer,
  children,
  onHide,
  visible,
}) {
  return (
    <Dialog header={header} footer={footer} onHide={onHide} visible={visible}>
      {children}
    </Dialog>
  );
}
